<div *ngIf="visibility" class="cand-modal upload-warning-modal">
    <article class="cand-modal__overlay">
        <em class="cand-modal__overlay__close circle-close-icon" (click)="closeModal()"></em>
        <h1 class="cand-modal__title">
            <span>{{ 'documentselectiontype.modal.warning.title' | i18n }} </span>
        </h1>
        <section class="cand-modal__content">
            <div class="upload-warning-modal__content">
                <div class="upload-warning-modal__warning-icon"></div>
                <span class="upload-warning-modal__message">
                    {{ 'documentselectiontype.jouve.error.' + errorKey | i18n }}
                </span>
                <span class="upload-warning-modal__description">
                    {{ 'documentselectiontype.modal.warning.description' | i18n }}
                </span>
            </div>
        </section>
        <footer class="cand-modal__footer">
            <button class="button button--previous modal-info__cancel-button" data-tag-commander [appTagCommander]="'tagCo.documentselection.documentselectiontype.forcesend.submit.button'" (click)="handleDocumentSend()">
                {{ 'documentselectiontype.modal.warning.button.use' | i18n }}
            </button>

            <button class="button button--primary modal-info__next-button" data-api-call-button data-tag-commander [appTagCommander]="'tagCo.documentselection.documentselectiontype.rescan.submit.button'" (click)="handleDocumentRescan()">
                <span>{{ 'documentselectiontype.modal.warning.button.rescan' | i18n }}</span>
            </button>
        </footer>
    </article>
    <div class="cand-modal__fade" (click)="closeModal()"></div>
</div>
